module.exports = __webpack_public_path__ + "media/images/web/home/index/header_bg_t-62902413a8baf36f0b42585ad154946b.webp";